module.exports = {
    parse: require('./lib/parse'),
    stringify: require('./lib/stringify')
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/html-parse-stringify2/index.js
// module id = 2724
// module chunks = 168707334958949